import { useFormContext } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useI18n } from 'next-localization';

type SummaryProps = {
  onStepChange: (step: number) => void;
};

type FieldValue = {
  value: string;
  displayName: string;
};

type StepFields = {
  [fieldName: string]: FieldValue;
};

const SummaryRow: React.FC<{ question: FieldValue }> = ({ question }) => (
  <tr key={question.displayName} style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}>
    <td className="h6 w-50 py-4">{question.displayName}</td>
    <td className="body-default w-50 py-4">{question.value?.toString() || '-'}</td>
  </tr>
);

const Summary = ({ onStepChange }: SummaryProps) => {
  const { summary } = useFormContext();
  const { t } = useI18n();

  const allFields: FieldValue[] = Object.values(summary)
    .sort((a, b) => a.index - b.index)
    .flatMap((step: StepFields) =>
      Object.values(step).filter((question) => !!question.displayName && !!question.value)
    );

  const printPDF = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.print();
  };

  return (
    <div className="col-8 print-container">
      <h3 className="mb-4">{t('summary')}</h3>
      <table aria-label="Summary data" className="w-100">
        <thead>
          <tr style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.3)' }}>
            <th className="w-50 py-4">Question</th>
            <th className="w-50 py-4">Your answer</th>
          </tr>
        </thead>
        <tbody>
          {allFields.map((question) => (
            <SummaryRow key={question.displayName} question={question} />
          ))}
        </tbody>
      </table>
      <div className="d-flex justify-content-between mt-5">
        <AbrdnButton
          buttonType="secondary"
          className="mt-5 text-link d-flex align-items-center"
          onClick={() => onStepChange(1)} // You can adjust this if needed
        >
          {t('edit')}
        </AbrdnButton>
        <AbrdnButton
          buttonType="secondary"
          className="mt-5 text-link d-flex align-items-center print"
          onClick={printPDF}
        >
          {t('print')}
        </AbrdnButton>
      </div>
    </div>
  );
};

export default Summary;
